import React from 'react';
import { CBadge } from '@coreui/react';

interface IPosition {
  status: string;
}

const PositionStatusBadge = (props: { position: IPosition }) => {
  const { position } = props;
  const positionStatus = position.status.toLowerCase();
  let badgeColor;
  if (positionStatus === 'open') {
    badgeColor = 'blue';
  } else {
    badgeColor = 'closed';
  }
  return (
    <CBadge color={badgeColor} title={position.status}>
      {position.status}
    </CBadge>
  );
};

export default PositionStatusBadge;
